module.exports = __webpack_public_path__ + "static/media/about-awards_fr.04f12411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-awards_fr.png
// module id = 1222
// module chunks = 0